import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', {
  state: () => ({
    // 当前选中的域名
    currentDomain: null,
    currentZoneId: null,

    // 加载状态
    loading: false,
    loadingMessage: '',

    // 通知消息
    notification: null,

    // 域名列表
    zones: [],
    zonesLoading: false,
  }),

  getters: {
    hasSelectedDomain: (state) => !!state.currentDomain,
  },

  actions: {
    /**
     * 设置当前域名
     */
    setCurrentDomain(domain, zoneId = null) {
      this.currentDomain = domain;
      this.currentZoneId = zoneId;
    },

    /**
     * 清除当前域名
     */
    clearCurrentDomain() {
      this.currentDomain = null;
      this.currentZoneId = null;
    },

    /**
     * 设置加载状态
     */
    setLoading(loading, message = '') {
      this.loading = loading;
      this.loadingMessage = message;
    },

    /**
     * 显示通知
     */
    showNotification({ type, title, message, duration = 5000 }) {
      this.notification = {
        type, // success, error, warning, info
        title,
        message,
        id: Date.now(),
      };

      // 自动隐藏通知
      if (duration > 0) {
        setTimeout(() => {
          this.hideNotification();
        }, duration);
      }
    },

    /**
     * 隐藏通知
     */
    hideNotification() {
      this.notification = null;
    },

    /**
     * 显示成功消息
     */
    showSuccess(message, title = 'Success') {
      this.showNotification({
        type: 'success',
        title,
        message,
      });
    },

    /**
     * 显示错误消息
     */
    showError(message, title = 'Error') {
      this.showNotification({
        type: 'error',
        title,
        message,
        duration: 8000, // 错误消息显示更长时间
      });
    },

    /**
     * 显示警告消息
     */
    showWarning(message, title = 'Warning') {
      this.showNotification({
        type: 'warning',
        title,
        message,
      });
    },

    /**
     * 显示信息消息
     */
    showInfo(message, title = 'Info') {
      this.showNotification({
        type: 'info',
        title,
        message,
      });
    },

    /**
     * 设置域名列表
     */
    setZones(zones) {
      this.zones = zones;
    },

    /**
     * 设置域名列表加载状态
     */
    setZonesLoading(loading) {
      this.zonesLoading = loading;
    },
  },
});
